import * as R from 'ramda';
import { categoryDisplay, dimensionValueDisplay, getRefAreaDimension } from '../dimension-utils';

const parseByAreas = (observations, refAreaDimension) => {
  if (R.isNil(refAreaDimension)) {
    return null;
  }
  const { __index, values = [] } = refAreaDimension;

  return R.pipe(
    R.keys,
    R.reduce((acc, key) => {
      const value = observations[key];
      const splitedKey = R.split(':', key);
      const areaValueIndex = Number(R.nth(__index, splitedKey));
      const areaValue = isNaN(areaValueIndex) ? null : R.nth(areaValueIndex, values);
      const areaId = R.prop('id', areaValue || {});
      return R.over(
        R.lensProp(areaId),
        vals => R.append({ splitedKey, value, areaValueIndex }, vals || []),
        acc,
      );
    }, {}),
  )(observations);
};

export default (
  { observations, dimensions },
  dimensionsWithValuesIndexedById,
  topoMap,
  display,
) => {
  const refAreaDimension = getRefAreaDimension(dimensions);
  const observationsByAreas = parseByAreas(observations, refAreaDimension);
  const topology = R.propOr({}, 'topology', topoMap);
  const areaSelection = R.propOr(null, 'areaSelection', topoMap);
  const topoAreas = R.pathOr(null, ['objects', areaSelection], topology);
  if (!observationsByAreas || !topoAreas) {
    return null;
  }
  const topoAreasWithData = R.map(areaGeometry => {
    const areaObservation = R.pipe(
      R.pathOr(null, ['properties', 'id']),
      id => R.propOr([], id, observationsByAreas),
      R.head,
    )(areaGeometry);
    const areaValueIndex = R.propOr(null, 'areaValueIndex', areaObservation);
    const areaValue = R.pathOr(null, ['values', areaValueIndex], refAreaDimension);
    return {
      ...areaGeometry,
      properties: {
        ...R.propOr({}, 'properties', areaGeometry),
        label: dimensionValueDisplay(display)(areaValue),
        value: R.head(R.propOr([], 'value', areaObservation)),
        category: categoryDisplay(
          R.propOr([], 'splitedKey', areaObservation),
          dimensions,
          dimensionsWithValuesIndexedById,
          refAreaDimension.id,
          display,
        ),
      },
    };
  }, topoAreas.geometries);
  return {
    objects: {
      areas: {
        type: topoAreas.type,
        geometries: topoAreasWithData,
      },
    },
    arcs: topology.arcs,
    bbox: topology.bbox,
    transform: topology.transform,
  };
};
